import { useEffect, useState } from "react";
import CustomSelectMultiple from "../../../common/interactive/CustomSelectMultiple";

export default function MultipleOptions({filtersValues, item, options, mainSelectAction, workQ, classes, hasRemove}) {

    const safeOptions = Array.isArray(options) ? options : []
    const [itemOptions, setItemOptions] = useState(safeOptions)

    useEffect(() => {
        setItemOptions(safeOptions)
        if (workQ && workQ.filter_conditions) {
            if (workQ.filter_conditions[`${item.key}_filter_type`] && workQ.filter_conditions[`${item.key}_filter_type`] == 1) {
                const allowed = workQ.filter_conditions[item.key]
                if (Array.isArray(allowed) && allowed.length) {
                    setItemOptions(safeOptions.filter(opt => allowed.includes(opt.value)))
                }
            }
        }
    }, [workQ, item, options])

    const preSelected = Array.isArray(filtersValues?.[item.key])
        ? filtersValues[item.key].map((entry) => entry)
        : undefined

    return <>
        <div className={classes.row}>
            <CustomSelectMultiple hasRemove={hasRemove} preSelectedValue={preSelected} optionsData={itemOptions} label={item.label} identifier={{type: item.key}} action={mainSelectAction}/>        
        </div>
    </>
}